export const ChartZoom = {
  enableXZoom(name, id = "clipOI") {
    let zoomChartBody = this.svg
      .append("g")
      .attr("class", name)
      .attr("clip-path", `url(#${id})`);
    this.svg
      .append("defs")
      .append("clipPath")
      .attr("id", id)
      .append("rect")
      .attr("width", this.svg.width)
      .attr("height", this.svg.height);
    this.svgAux = zoomChartBody;
  }
};
